import { useState } from 'react';
import * as yup from 'yup';

const useCreateRule = () => {
  const benefitPlansDataDummy = [
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
    {
      planName: 'Gold PPO Healthcare Plan',
      effectiveDate: '12/21/2023',
      type: 'Medical',
      status: false,
    },
  ];
  const [ruleName, setRuleName] = useState('');
  const [enrollmentPeriodFrom, setEnrollmentPeriodFrom] = useState('');
  const [enrollmentPeriodThrough, setEnrollmentPeriodThrough] = useState('');
  const [effectiveDate, setEffectiveDate] = useState('');
  const [benefitPlans, setBenefitPlans] = useState(benefitPlansDataDummy);
  const [selectedBenefitPlans, setSelectedBenefitPlans] = useState(
    benefitPlansDataDummy,
  );

  const schema = yup.object({
    ruleName: yup.string().required('Enter rule name '),
    effectiveDate: yup.string().required('Enter effective date'),
  });
  return {
    schema,
    ruleName,
    setRuleName,
    enrollmentPeriodFrom,
    setEnrollmentPeriodFrom,
    enrollmentPeriodThrough,
    setEnrollmentPeriodThrough,
    effectiveDate,
    setEffectiveDate,
    benefitPlans,
    selectedBenefitPlans,
  };
};

export default useCreateRule;
